// formReducer.js
const initialState = {
    pk_opSlotId:'',
    pk_opPrvKeyHandle: '',
    pk_opPubKeyHandle: '',
    pk_opKeyId: ''
};

const TokenGenerateKeyReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_TOKEN_GENERATE_KEY_RESPONSE':
            return {
                ...action.payload
            };
        case 'RESET_CERTIFICATE_FLOW':
            return initialState;
        default:
            return state;
    }
};

export default TokenGenerateKeyReducer;
